import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


// 공용함수 파일 import
import common from './plugins/common.js';
Vue.use(common);

// axios 전역 변수 설정
import axios from 'axios';
Vue.prototype.axios = axios;

// lodash
import __ from 'lodash';
Vue.prototype.__ = __;

// 쿠키
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import InfiniteLoading from 'vue-infinite-loading'
Vue.use(InfiniteLoading, {
  /* options */
  slots: {
    noMore: 'END',
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
